// extracted by mini-css-extract-plugin
export default {"container":"nav_item-module__container--1x6s5"};